fx.ns("shared.popups", class CreateBookError extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personNotHappy );

        this.contentWidth = 550;
        this.contentHeight = 225;
    }

    create()
    {
        super.create();

        this.addChild(new fx.components.Text({text:fx.text("Je rencontre un problème"), className:"title center"}));
        this.addChild(new fx.components.Text({text:fx.text("J'ai rencontré un problème en essayant de créer votre ouvrage. Veuillez-ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>."), className:"text center"}));

        this.okButton = new fx.components.Button({label : fx.text("Ré-essayer"), type : "filled"});
        this.cancelButton = new fx.components.Button( {label : fx.text("Quitter")} );

        this.addFooterChild(this.cancelButton, {width : 200});
        this.addFooterChild(this.okButton, {width :200});
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onRetry, this.okButton);
        this.on("click", this.onClose, this.cancelButton);
    }

    onClose()
    {
        this.data.event("navigate-back");
    }
    
    onRetry()
    {
        document.location.reload();
    }
});